import { getLoggedUser } from "../../../utils/helpers/tokenStorage";

const getLastValue = (isCampaignList: boolean) => {
  const user = getLoggedUser();
  const value = localStorage.getItem(
    "lastSelectedCategoryValue" + user?.user?.user?.userId + (isCampaignList ? 'campaign' : 'delivery')
  );
  return value;
};

export default getLastValue;
